import api from './../../Api.js';

function User_helper(props){
		
	this.props = props; 

}

 

User_helper.prototype.getMyStudents = async function(){
 
	var req = await api.getMyStudents().then(async (res) => {
    	
    	return {status:200,data:res.data};
       
    }).catch(error => {

      if(error.response.status === 400){

      	return {status:400,data:error.response};

      }

      return false;

    });

    return req;
    
}



export default User_helper;